import { render, staticRenderFns } from "./twilio.vue?vue&type=template&id=6c732d9d&scoped=true&"
var script = {}
import style0 from "./twilio.vue?vue&type=style&index=0&id=6c732d9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c732d9d",
  null
  
)

export default component.exports